"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("../styles/SCSS/components/_energycertificate.scss");
var _translation = _interopRequireDefault(require("../Translation/translation"));
var _reactRedux = require("react-redux");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const EnergyList = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
const BrixelEnergyCertificate = ({
  lang,
  value,
  translations
}) => {
  const energyValueRef = (0, _react.useRef)(null);
  const parentEnergyValueRef = (0, _react.useRef)(null);
  const [arrowStartPos, setArrowStartPos] = _react.default.useState(0);
  const [maxWidthArrow, setMaxWidthArrow] = _react.default.useState(250);
  const localWindow = typeof window !== 'undefined' ? window : null;
  (0, _react.useEffect)(() => {
    if (energyValueRef?.current && parentEnergyValueRef?.current) {
      const parentEnergyValueRefLeftPosition = parentEnergyValueRef?.current?.getBoundingClientRect().left;
      const energyValueRefPosition = energyValueRef?.current?.getBoundingClientRect().left;
      if (window.innerWidth < 540) {
        setMaxWidthArrow(90);
      } else if (window.innerWidth < 769) {
        setMaxWidthArrow(150);
      } else {
        if (energyValueRefPosition - parentEnergyValueRefLeftPosition < 250) setMaxWidthArrow(energyValueRefPosition - parentEnergyValueRefLeftPosition);else setMaxWidthArrow(250);
      }
      setArrowStartPos(energyValueRefPosition - parentEnergyValueRefLeftPosition);
    }
  }, [energyValueRef?.current, parentEnergyValueRef?.current, value, document && document.body.clientWidth, localWindow]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "brixel-energy-certificate brdRadius p-md-4 p-2 pb-5 pb-md-5 brdRadius",
    ref: parentEnergyValueRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f a-c jc-b"
  }, EnergyList.map((energyCertificate, index) => (/*#__PURE__*/_react.default.createElement("div", {
    ref: energyCertificate === value ? energyValueRef : null,
    key: `energy${index.toString()}`,
    className: `singleEnergyValue ${energyCertificate === value ? 'active' : ''} ${value}`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "labelValue"
  }, energyCertificate))))), value !== 'A' && value !== 'B' && (/*#__PURE__*/_react.default.createElement("div", {
    className: "arrowIndicator",
    style: {
      left: arrowStartPos,
      maxWidth: maxWidthArrow,
      transform: `translate(-${maxWidthArrow}px, 0`
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "arrowLeft"
  }), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      position: 'relative',
      left: window.innerWidth < 540 ? '-24px' : 'unset'
    },
    className: "mx-a dis-b ta-c txtGreen400 mt-2-neg ws-nw fsize-300"
  }, (0, _translation.default)('Renovation potential', lang, undefined, translations)))));
};
const mapStateToProps = state => ({
  translations: (0, _lodash.get)(state, 'translations', {})
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(BrixelEnergyCertificate);